export default "__VITE_ASSET__HHNMZAdH__"